"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoSettings = void 0;

var _getProperty = require("../../../util/getProperty");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControllerID = 2;

var VideoSettings = /*#__PURE__*/function () {
  function VideoSettings() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, VideoSettings);

    // setup properties
    this.id = opts.id || ControllerID++;
    this._loop = false;
    this._muted = true;
    this._zoom = false;
    this._locked = false;
  }

  _createClass(VideoSettings, [{
    key: "locked",
    get: function get() {
      return this._locked;
    },
    set: function set(val) {
      if (this._locked !== val) {
        this._locked = val;
      }
    }
  }, {
    key: "loop",
    get: function get() {
      return this._loop;
    },
    set: function set(val) {
      if (this._loop !== val) {
        this._loop = val;
      }
    }
  }, {
    key: "zoom",
    get: function get() {
      return this._zoom;
    },
    set: function set(val) {
      if (this._zoom !== val) {
        this._zoom = val;
      }
    }
  }, {
    key: "muted",
    get: function get() {
      return this._muted;
    },
    set: function set(val) {
      if (this._muted !== val) {
        this._muted = val;
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!id) {
        throw "VideoSettings.getInstance: id is required";
      }

      var controller = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!controller) {
        controller = new VideoSettings({
          id: id
        });

        this._instances.push(controller);
      }

      return controller;
    }
  }, {
    key: "findInstance",
    value: function findInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var controller = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!controller) {
        controller = null;
      }

      return controller;
    }
  }]);

  return VideoSettings;
}();

exports.VideoSettings = VideoSettings;

_defineProperty(VideoSettings, "_instances", []);